export default{
    methods:{
        pxToRem(px){
            return `${px/14*0.5}rem`
        },
        //'hh:mm:ss'
        timeFormat(n){
            const h=('0'+Math.floor(n/60)).substr(-2)
            const m=('0'+Math.floor(n%60)).substr(-2)
            const h1=('0'+Math.floor(n/3600)).substr(-2)
            const m1=('0'+Math.floor(n%3600/60)).substr(-2)
            const s1=('0'+Math.floor(n%60)).substr(-2)
            return n<3600?(h+':'+m):(h1+':'+m1+':'+s1)
        }
    }
}